import logger from '@goldcast/logger';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { getEnv } from './utils/env';

import { sessionService } from '@/services/sessionService';
import store from '@/store';
import { getCurrentDeviceType } from '@/utils/deviceType';

const analytics: AnalyticsBrowser = AnalyticsBrowser.load(
  {
    writeKey: getEnv('VUE_APP_SEGMENT_KEY') || '',
    cdnURL: getEnv('VUE_APP_ANALYTICS_CDN_URL') || ''
  },
  {
    integrations: getEnv('VUE_APP_SEGMENT_INTEGRATION_CONFIG') as any
  }
);

const originalTrack = analytics.track;

analytics.track = (...args) => {
  const currentUser = store?.getters['user/getCurrentUser'];
  const eventName = args[0] as string;
  const props = {
    ...args[1],
    email: currentUser?.email,
    is_content_lab_standalone: currentUser?.is_content_lab_standalone,
    is_free_trial: store?.getters['org/getCurrentOrg']?.is_free_trial,
    email_verified: store?.getters['user/getIsCurrentUserEmailVerified']
  };

  if (store?.getters['org/getCurrentOrg']?.useLogrocketTrack) {
    logger.track(eventName, props);
  }

  if (getEnv('VUE_APP_AMPLITUDE_ENABLED') === 'true') {
    logger.trackAmplitude(eventName, props);
  }

  return originalTrack(eventName, props);
};

(window.analytics as unknown as AnalyticsBrowser) = analytics;

const trackEvent = (eventName: string, eventProperties: { [key: string]: any }) => {
  analytics.track(eventName, eventProperties);
};

export function trackMouseClick(e: MouseEvent) {
  const target = e.target as HTMLElement;

  if (!target) {
    return;
  }

  const closestButton = target.closest('button');
  if (closestButton?.dataset?.testid) {
    trackEvent('button_click', { button_name: closestButton.dataset.testid });
  }

  const closestLink = target.closest('a');
  if (closestLink?.dataset?.testid) {
    trackEvent('link_click', { button_name: closestLink.dataset.testid });
  }
}

export const trackLoginOrLogoutEvent = ({
  eventType,
  isSuccess,
  loginMethod
}: {
  eventType: 'Login' | 'Logout';
  isSuccess: boolean;
  loginMethod?: string;
}) => {
  const payload = {
    device_type: getCurrentDeviceType(),
    action: eventType,
    is_success: isSuccess,
    session_id: sessionService.getSessionId(),
    ...(loginMethod && eventType === 'Login' && { login_method: loginMethod })
  };
  analytics.track('studioLoginLogout', payload);
};

export default analytics;
